/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WhatsAppConnectEntry
 */
export interface WhatsAppConnectEntry {
  /**
   *
   * @type {string}
   * @memberof WhatsAppConnectEntry
   */
  destination: string;
  /**
   *
   * @type {string}
   * @memberof WhatsAppConnectEntry
   */
  prefillText: string;
  /**
   *
   * @type {Date}
   * @memberof WhatsAppConnectEntry
   */
  expiresAt: Date;
}

/**
 * Check if a given object implements the WhatsAppConnectEntry interface.
 */
export function instanceOfWhatsAppConnectEntry(
  value: object
): value is WhatsAppConnectEntry {
  if (!("destination" in value) || value["destination"] === undefined)
    return false;
  if (!("prefillText" in value) || value["prefillText"] === undefined)
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  return true;
}

export function WhatsAppConnectEntryFromJSON(json: any): WhatsAppConnectEntry {
  return WhatsAppConnectEntryFromJSONTyped(json, false);
}

export function WhatsAppConnectEntryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WhatsAppConnectEntry {
  if (json == null) {
    return json;
  }
  return {
    destination: json["destination"],
    prefillText: json["prefill_text"],
    expiresAt: new Date(json["expires_at"]),
  };
}

export function WhatsAppConnectEntryToJSON(json: any): WhatsAppConnectEntry {
  return WhatsAppConnectEntryToJSONTyped(json, false);
}

export function WhatsAppConnectEntryToJSONTyped(
  value?: WhatsAppConnectEntry | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    destination: value["destination"],
    prefill_text: value["prefillText"],
    expires_at: value["expiresAt"].toISOString(),
  };
}
